// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nt35","controls":"styles_controls__1afx-","charLimit":"styles_charLimit__2u51V","input":"styles_input__2iVNw","send":"styles_send__3jlHk"};